<template>
  <div class="shopsolradio-container">
    <!-- shopsol bannerl1 -->
    <div class="shopsolradio-banner1">
      <img class="shopsolradio-banner1-img" src="/media/img/event/shopsol_radio_banner1.png" />
      <div class="app-download-btngroup">
        <button class="app-download-btn" @click="goPlayStore">
          <img class="google-icon" src="/media/images/icon/googlestore-icon.png" alt="googlestore-icon.png" />
          Google Play
        </button>
        <button class="app-download-btn apple" @click="goAppleStore">
          <img class="apple-icon" src="/media/images/icon/apple-logo-icon.png" alt="googlestore-icon.png" />
          App Store
        </button>
      </div>
    </div>

    <!-- shopsol bannerl2 -->
    <div class="shopsolradio-banner2"></div>
    <!-- shopsol bannerl3 -->
    <img class="shopsolradio-banner3" src="/media/img/event/shopsol_radio_banner2.png" />
    <!-- shopsol bannerl4 -->
    <div class="shopsolradio-banner4">
      <p class="banner4-desc">
        상황별 Mix와 장르별 추천 채널까지 <br />
        다양하게 즐길 수 있는 <br />
        나만의 AI 음악라디오, <br />
        <strong>래디오</strong>를 지금 만나보세요.
      </p>
      <button class="applink-btn" @click="goDownloadApp">앱 다운로드</button>
    </div>
  </div>
</template>
<script>
import { getMobileOS } from '@/utils/Utils';

export default {
  methods: {
    goPlayStore() {
      window.open(`https://play.google.com/store/apps/details?id=com.aplayz.raidio`, '_blank');
    },
    goAppleStore() {
      window.open(`https://itunes.apple.com/app/id6736726668`, '_blank');
    },
    goDownloadApp() {
      const os = getMobileOS();
      if (os === 'Android' || os === 'Other') {
        this.goPlayStore();
      } else if (os === 'iOS') {
        this.goAppleStore();
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/shopsolradio/shopsolradio.css"></style>
